import BusinessIcon from "@mui/icons-material/Business";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	IconButton,
	Link,
	Stack,
	styled,
	Tooltip,
	Typography,
} from "@mui/material";
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { useState } from "react";
import { LinkedinJobPosting } from "../../api/job/linkedin_job_posting";
import { formatFriendlyDate, formatRelativeTime } from "../../utils/date-formatting";

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip {...props} classes={{ popper: className }} />
))({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: 700,
	},
});

const PersonJobPosting = ({
	jobPostings,
	personPage = false,
}: {
	jobPostings: LinkedinJobPosting[];
	personPage?: boolean;
}) => {
	const [fullDescription, setFullDescription] = useState<boolean>(false);

	if (jobPostings.length === 0) {
		return null;
	}

	return (
		<Box data-component="job-postings">
			<Typography
				variant={personPage ? "h5" : "subtitle1"}
				sx={{ m: personPage ? 1 : 0, mb: 1 }}
			>
				Job Postings
			</Typography>
			{jobPostings.map((jp) => (
				<Accordion key={jp.id} data-component="job-posting-item">
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Stack
							direction="row"
							justifyContent="space-between"
							width="100%"
						>
							<Stack spacing={1}>
								<CustomWidthTooltip
									onClose={() => setFullDescription(false)}
									onOpen={() => setFullDescription(false)}
									title={
										<Box sx={{ minWidth: "200px" }}>
											<Stack spacing={1}>
												<Typography
													variant="caption"
													fontWeight="bold"
												>
													{jp.job_title}
												</Typography>
												<Typography variant="caption">
													Expire:{" "}
													{formatFriendlyDate(jp.expire_at)}
												</Typography>
												<Typography
													variant="caption"
													sx={
														!fullDescription
															? {
																	overflow: "hidden",
																	textOverflow:
																		"ellipsis",
																	display:
																		"-webkit-box",
																	WebkitLineClamp:
																		"8",
																	WebkitBoxOrient:
																		"vertical",
																}
															: undefined
													}
												>
													{jp.description_text}
												</Typography>
												{!fullDescription && (
													<Link
														variant="caption"
														sx={{ cursor: "pointer" }}
														onClick={() =>
															setFullDescription(
																(prev) => !prev
															)
														}
													>
														Show more
													</Link>
												)}
											</Stack>
										</Box>
									}
								>
									<Typography
										variant="caption"
										fontWeight="bold"
										sx={{ cursor: "pointer" }}
									>
										{jp.job_title}
									</Typography>
								</CustomWidthTooltip>
								<Typography variant="caption">
									{jp.company_name}, {jp.location_name},{" "}
									{formatRelativeTime(jp.listed_at)} ago
								</Typography>
							</Stack>
							<Box>
								<IconButton
									target="_blank"
									href={`/company/${jp.company}/`}
								>
									<BusinessIcon />
								</IconButton>
								<IconButton target="_blank" href={jp.url}>
									<LinkedInIcon />
								</IconButton>
							</Box>
						</Stack>
					</AccordionSummary>
					<AccordionDetails>
						<Typography component="p" sx={{ whiteSpace: "pre-line" }}>
							{jp.description_text}
						</Typography>
					</AccordionDetails>
				</Accordion>
			))}
		</Box>
	);
};

export default PersonJobPosting;
